import { Outlet } from "react-router-dom";
import { Access } from "@/features/farmer/domain/farmer-interface";
// @ts-ignore
import AccessDeny from "@assets/images/access-deny.png";

interface PrivateRouteProps {
  access: Access[];
  route: string;
}

const PrivateRoute = ({ access, route }: PrivateRouteProps) => {
  let hasAccess = access.some((acc) => {
    if (acc.children.length > 0) {
      return !!acc.children.find(({ name }) => name === route);
    } else {
      return acc.name === route;
    }
  });

  if (hasAccess) {
    return (
      <div>
        <Outlet />
      </div>
    );
  } else {
    return (
      <div className="w-[600px] m-auto mt-10">
        <img alt="access-deny" src={AccessDeny} />
      </div>
    );
  }
};

export default PrivateRoute;
